import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/common/Layout/Layout';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import VerifyEmail from './pages/VerifyEmail';
import ResendVerification from './pages/ResendVerification';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ComingSoonFeature from './pages/ComingSoonFeature';
import UploadForm from './components/video/UploadForm/UploadForm';
import VideoMerge from './components/video/VideoMerge/VideoMerge';

// Basic styling
const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #0f172a;
  color: #e2e8f0;
`;

function App() {
  return (
    <AuthProvider>
      <AppContainer>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/resend-verification" element={<ResendVerification />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/coming-soon/:featureId" element={<ComingSoonFeature />} />
              <Route path="/extraction" element={<UploadForm />} />
              <Route path="/merge" element={<VideoMerge />} />
            </Routes>
          </Layout>
        </Router>
      </AppContainer>
    </AuthProvider>
  );
}

export default App;


